import { api } from './client'

export type SettingValueType = 'string' | 'int' | 'bool' | 'json'
export type SettingSource = 'db' | 'env' | 'default'
export type SettingApplyMode = 'runtime' | 'restart'

export interface ConfigItem {
  key: string
  is_secret: false
  value: unknown
  source: SettingSource
  value_type: SettingValueType
  apply_mode: SettingApplyMode
  group: string
  description: string
}

export interface SecretStatus {
  name: string
  configured: boolean
  masked: string | null
  last_rotated: string | null
  last_test: { ok: boolean; at: string } | null
  description: string
  fields: string[]
  error?: string
}

export interface SettingsResponse {
  config: ConfigItem[]
  secrets: SecretStatus[]
}

export interface DbStatus {
  connected: boolean
  host: string
  port: number
  database: string
  latency_ms: number | null
  error: string | null
}

export interface SecretTestResult {
  ok: boolean
  detail: Record<string, unknown>
}

export const settingsApi = {
  get: () => api.get<SettingsResponse>('/v1/settings').then((r) => r.data),
  updateConfig: (key: string, value: unknown) =>
    api.put(`/v1/settings/${key}`, { value }).then((r) => r.data),
  updateSecret: (name: string, fields: Record<string, string>) =>
    api.put(`/v1/settings/secrets/${name}`, { fields }).then((r) => r.data),
  testSecret: (name: string, target: string) =>
    api.post<SecretTestResult>(`/v1/settings/secrets/${name}/test`, { target }).then((r) => r.data),
  dbStatus: () => api.get<DbStatus>('/v1/settings/db-status').then((r) => r.data),
}
